import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16 3H8a2 2 0 0 0-2 2v14.936a1 1 0 0 0 1.62.785L12 17.263l4.38 3.458a1 1 0 0 0 1.62-.785V5a2 2 0 0 0-2-2"
    }
  )
);
var SvgBookmarkFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkFilled_default = SvgBookmarkFilled;

export { BookmarkFilled_default as default };
